import { createRouter, createWebHistory } from 'vue-router';
import type { Middleware, MiddlewareContext } from '@/types/router';
import type { RouteRecordRaw } from 'vue-router';

import middlewarePipeline from '@/middleware/middlewarePipeline';

import home from './home';
import livestreams from './livestreams';
import presenters from './presenters';
import users from './users';
import muslimHub from './muslim-hub';
import quranTutors from './quran-tutors';
import transactions from './transactions';
import bookmarks from './bookmarks';
import donations from './donations';
import broadcasts from './broadcasts';
import auth from './auth';
import errors from './errors';

const arr_routes = [
    home,
    livestreams,
    presenters,
    users,
    muslimHub,
    quranTutors,
    transactions,
    bookmarks,
    donations,
    broadcasts,
    auth,
    errors
];

const routes: RouteRecordRaw[] = arr_routes.flat(1);

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const metaTitle = to.meta.title
        ? `Admin Sahabat Ngaji · ${to.meta.title}`
        : 'Admin Sahabat Ngaji';

    document.title = metaTitle;

    const middlewares = to.meta.middleware as Middleware[] | undefined;

    if (!middlewares || !middlewares.length) return next();

    const context: MiddlewareContext = { to, from, next };

    return middlewares[0]!({
        ...context,
        next: middlewarePipeline(context, middlewares, 1)
    });
});

export default router;
